1
<template>
  <section class="section-messages">
    <cleaner-detail-mobile :id="$route.query.pid" class="d-block d-md-none"/>
    <div class="row">
      <div class="col-md-4 col-12">
        <cleaner-detail :id="$route.query.pid"/>
      </div>
      <div class="col-md-1">&nbsp;</div>
      <!-- /.col left -->
      <div class="col-md-7 col-12">
        <div class="row">
          <div class="col-10 col-sm-10 col-md-9 col-lg-10 p-0">
            <div class="panel-quote-flush panel-quote card panel-quote-right-white" style="background-color: white;">
              <div class="card-body p-0">
                <div class="panel-text-message">
                  <textarea ref="message" class="text-message border-secondary" rows="4" v-model="message"></textarea>
                </div>
                <div class="panel-text-message text-right" style="background-color: #EEE">
                  <button class="btn btn-info"
                          :disabled="state.isRequesting"
                          @click="sendMessage">{{ $t(isSendingMessage) }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-2 col-sm-2 col-md-3 col-lg-2 text-right p-0">
            <img v-lazy="userImage" class="rounded-circle message-user-img" alt="user image" v-if="userImage">
          </div>
        </div>
        <template v-if="messages === null">
          <loader/>
        </template>
        <template v-else>
          <template v-if="messages.length === 0 && queryData.page === 0">
            <notification classname="alert-info" body="message.no_data"/>
          </template>
          <template v-else>
            <div class="mt-5">
              <ul class="list-unstyled">
                <message v-for="message in messages" v-bind:key="message.id" :message="message"/>
              </ul>
            </div>
            <div class="text-center">
              <a href=""
                 class="btn btn-outline-info"
                 :disabled="state.isFetching"
                 @click.prevent="fetchMessages"
                 v-if="state.isMore"> {{ $t(isLoadMore) }}
              </a>
            </div>
          </template>
        </template>
      </div>
      <!-- /.col right -->
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import CleanerDetail from './CleanerDetail'
  import CleanerDetailMobile from './CleanerDetailMobile'
  import Loader from '../loader/Loader'
  import Message from './Message'
  import Notification from '../partials/Notification'

  export default {
    components: {
      CleanerDetail,
      CleanerDetailMobile,
      Loader,
      Message,
      Notification
    },
    data () {
      return {
        queryData: {
          page: 0,
          chat_room_id: this.$route.query.cid,
          user_id: null,
          professional_id: this.$route.query.pid
        },
        message: null,
        userImage: null
      }
    },
    computed: {
      ...mapGetters({
        isLoadMore: 'message/isLoadMore',
        isSendingMessage: 'message/isSendingMessage',
        messages: 'message/getMessages',
        state: 'message/getState',
        user: 'auth/getUser'
      })
    },
    watch: {
      '$route.query': {
        handler (newQuery) {
          // console.log('watch triggered', newQuery)
          this.$router.push({
            path: '/message',
            query: {
              cid: newQuery.cid,
              pid: newQuery.pid
            }
          })
        }
      }
    },
    methods: {
      fetchMessages () {
        this.queryData.page++
        this.$store.dispatch('message/LOAD_MESSAGE_LIST', this.queryData)
      },
      sendMessage () {
        if (this.message) {
          const submitData = {
            chat_room_id: this.$route.query.cid,
            user_id: this.user.id,
            professional_id: this.$route.query.pid,
            message: this.message.trim(),
            message_type_id: 1,
            sender_type: 'user'
          }
          this.$store.dispatch('message/ADD_MESSAGE', submitData)
          this.message = ''
        } else {
          this.$refs.message.focus()
        }
      }
    },
    mounted () {
      if (this.user) {
        this.queryData.user_id = this.user.id
        this.userImage = this.user.picture
        this.$store.commit('message/SET_EMPTY_MESSAGE_LIST')
        this.$store.dispatch('message/LOAD_MESSAGE_LIST', this.queryData)
      }
    },
    destroyed () {
      this.$store.commit('message/SET_EMPTY_MESSAGE_LIST')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/message/Index.vue